export const apiErrorCodes = {
  LOCATION_NOT_AVAILABLE: 1789
}